// buildActiveFacetPills.js

export const MAX_VISIBLE_FILTER_PILLS = 3;

const normalizeValue = (value) => String(value || '').trim();

/**
 * Builds toolbar pills for active catch-all lens selections.
 *
 * @param {Array} facetFields
 * @param {object} facetSelections
 * @param {object} [options]
 * @param {boolean} [options.isBoardMode=false]
 * @param {string|null} [options.boardFieldKey=null]
 * @returns {Array<{ fieldKey: string, fieldLabel: string, valueLabel: string, label: string }>}
 */
export function buildActiveFacetPills(
    facetFields,
    facetSelections,
    {
        isBoardMode = false,
        boardFieldKey = null,
    } = {},
) {
    const fields = Array.isArray(facetFields) ? facetFields : [];
    const selections = facetSelections && typeof facetSelections === 'object'
        ? facetSelections
        : {};
    const excludedBoardKey = isBoardMode
        ? normalizeValue(boardFieldKey)
        : '';

    return fields
        .map((field) => {
            const fieldKey = normalizeValue(field?.key);
            if (!fieldKey || (excludedBoardKey && fieldKey === excludedBoardKey)) {
                return null;
            }

            const selectedValue = normalizeValue(selections[fieldKey]);
            if (!selectedValue) return null;

            const selectedOption = (Array.isArray(field?.options) ? field.options : []).find((option) => {
                return normalizeValue(option?.value) === selectedValue;
            });

            const valueLabel = String(
                selectedOption?.label || selectedValue,
            ).trim() || selectedValue;
            const fieldLabel = String(field?.label || fieldKey).trim() || fieldKey;

            return {
                fieldKey,
                fieldLabel,
                valueLabel,
                label: `${fieldLabel}: ${valueLabel}`,
            };
        })
        .filter(Boolean);
}
